import React, { useState, useEffect } from 'react';
import './Title.css';

const Title = () => {
  return (
    <div className='heading'>
      <img className='logo' src="crosscope-logo-new.svg" alt="" />

      <div className='heading-title'>
        <h2>Nestin as a diagnostic and prognostic marker for combined hepatocellular-cholangiocarcinoma</h2>
      </div>
      <div className='heading-title'>
        <p>Please <a href="https://accounts.crosscope.com/signup" target='_blank'>login to your Crosscope Scholar account</a> to browse these whole slide images in the digital pathology viewer</p>
      </div>
    </div>
  );
}

export default Title;

